// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Notification delivery channel.
 */
export enum NotificationType {
  SMS = 0,
  EMAIL = 1,
  WHATSAPP = 2,
}
